import "../../index.css";

import { init } from "./client";
import { initSentry } from "./sentry";

initSentry();
init();
